import React, { useId, useState } from "react";

type Props = {
    label: string;
    value: string;
    onChange: (v: string) => void;
    placeholder?: string;
    autoComplete?: string;
    disabled?: boolean;
    errorText?: string | null;
};

function EyeIcon({ off }: { off?: boolean }) {
    // нейтральная “best-practice” иконка (простая, не выпирает)
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            className="opacity-90"
            aria-hidden="true"
        >
            {off ? (
                <>
                    <path
                        d="M3 3l18 18"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                    />
                    <path
                        d="M10.5 10.5a2.5 2.5 0 0 0 3.5 3.5"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                    />
                    <path
                        d="M6.2 6.2C4.4 7.6 3.1 9.4 2.3 12c1.7 5.2 6 8 9.7 8 1.5 0 3-.3 4.4-1"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.9 4.3A9.6 9.6 0 0 1 12 4c3.7 0 8 2.8 9.7 8-.5 1.5-1.2 2.8-2.1 3.9"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ) : (
                <>
                    <path
                        d="M2.3 12C4 6.8 8.3 4 12 4s8 2.8 9.7 8c-1.7 5.2-6 8-9.7 8s-8-2.8-9.7-8Z"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinejoin="round"
                    />
                </>
            )}
        </svg>
    );
}

export const PasswordField: React.FC<Props> = ({
                                                   label,
                                                   value,
                                                   onChange,
                                                   placeholder,
                                                   autoComplete,
                                                   disabled,
                                                   errorText,
                                               }) => {
    const id = useId();
    const [show, setShow] = useState(false);

    return (
        <div>
            <label htmlFor={id} className="block text-[11px] text-slate-300 mb-1">
                {label}
            </label>

            <div className="relative">
                <input
                    id={id}
                    type={show ? "text" : "password"}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    disabled={disabled}
                    className={[
                        "w-full rounded-xl border px-3 py-2 pr-11 text-xs outline-none",
                        "border-slate-700 bg-slate-950 text-slate-100 focus:border-sky-500",
                        "disabled:opacity-60",
                    ].join(" ")}
                />

                <button
                    type="button"
                    onClick={() => setShow((v) => !v)}
                    disabled={disabled}
                    aria-label={show ? "Скрыть пароль" : "Показать пароль"}
                    className={[
                        "absolute right-2 top-1/2 -translate-y-1/2",
                        "h-8 w-8 grid place-items-center rounded-lg",
                        // ✅ ключ: полупрозрачная подложка — видна и на белом autofill, и на тёмном фоне
                        "bg-black/10 hover:bg-black/20",
                        // ✅ цвет иконки нейтральный
                        "text-slate-500 hover:text-slate-200",
                        "transition",
                        "disabled:opacity-60",
                    ].join(" ")}
                >
                    <EyeIcon off={show} />
                </button>
            </div>

            {errorText && (
                <div className="mt-1 text-[10px] text-red-300">{errorText}</div>
            )}
        </div>
    );
};
